import { jsx } from "panel";
import { EntryPart } from "common/query-builder/query-entry-section/types";
import { SelectTheme } from "common/components/select/constants";
import { ButtonSize, ButtonTheme, ButtonType } from "common/components/button/constants";
import { SelectEl } from "common/components/select";
import { PropertyValuesScreenEl } from "common/widgets/property-filter-menu/property-values-screen";
import { ButtonEl } from "common/components/button";
import { Placement } from "common/components/tooltip/types";
import { PropertyFilter } from "common/widgets/property-filter-menu/models/property-filter";
export function template() {
  const { section, index } = this.params;
  const shouldShow = section.shouldShowMultiAttributionBehaviorIndex(index);
  const filterSegment = this.state.filterSegment;
  if (!filterSegment || !shouldShow) {
    return /* @__PURE__ */ jsx("span", null);
  }
  const filter = new PropertyFilter(filterSegment);
  const { index: activeIndex, part: activePart } = section.state.openEntry;
  const isActiveEntry = activeIndex === index;
  const isFilterOperatorOpen = isActiveEntry && activePart === EntryPart.MultiAttributionBehaviorFilterOperator;
  const isFilterValueOpen = isActiveEntry && activePart === EntryPart.MultiAttributionBehaviorFilterValue;
  return /* @__PURE__ */ jsx("div", {
    sel: ".subitem-text.multi-attribution-behavior-filter"
  }, /* @__PURE__ */ jsx(SelectEl, {
    sel: ".subitem-select.multi-attribution-behavior-filter-operator",
    attrs: {
      elref: `filterOperator`,
      open: isFilterOperatorOpen,
      theme: SelectTheme.QbSubitem,
      size: ButtonSize.Small,
      sections: this.getMultiAttributionBehaviorFilterOperatorSections(),
      "menu-width": null
    },
    on: {
      menuChange: (ev) => section.onMultiAttributionBehaviorFilterOperatorMenuChange(ev, index),
      change: (ev) => this.selectFilterOperator(ev.detail.item.value)
    }
  }), /* @__PURE__ */ jsx(SelectEl, {
    sel: ".subitem-select.multi-attribution-behavior-filter-value",
    attrs: {
      elref: `filterValueSelect`,
      label: filter.isValid() ? filter.getValuesLabel() : `Select value\u2026`,
      open: isFilterValueOpen,
      theme: SelectTheme.QbSubitem,
      size: ButtonSize.Small
    },
    on: {
      menuChange: (ev) => {
        section.onMultiAttributionBehaviorFilterValueMenuChange(ev, index);
      }
    }
  }, isFilterValueOpen && /* @__PURE__ */ jsx(PropertyValuesScreenEl, {
    attrs: {
      elref: `filterValue`,
      slot: `body`,
      "property-filter": filter.getAttributes(),
      "display-value-only": true,
      "hide-undefined-value": true,
      "project-id": section.attr(`project-id`),
      "workspace-id": section.attr(`workspace-id`)
    },
    on: {
      commitPropertyFilter: (ev) => this.selectPropertyFilter(ev.detail.propertyFilter)
    }
  })), /* @__PURE__ */ jsx(ButtonEl, {
    sel: ".delete-subitem-button",
    attrs: {
      theme: ButtonTheme.Tertiary,
      size: ButtonSize.Inline,
      icon: `x`,
      role: `button`,
      type: ButtonType.Destructive,
      tooltip: {
        text: `Remove touchpoint filter`,
        placement: Placement.Top
      }
    },
    on: {
      click: () => this.removeFilter()
    }
  }));
}
